var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-form-file',_vm._b({ref:"fileinput",staticClass:"mb-2",attrs:{"accept":".png,.jpeg,.jpg","placeholder":_vm.placeholderText,"drop-placeholder":"Drop file here..."},on:{"input":_vm.fileInput}},'b-form-file',_vm.$attrs,false))}
var staticRenderFns = []

export { render, staticRenderFns }